var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3369_8566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 6.4125H5.55005V1.93125C5.55005 1.33125 6.03755 0.84375 6.63755 0.84375H22.8938C23.4938 0.84375 23.9813 1.33125 23.9813 1.93125V6.4125H24Z",
    fill: "#41A5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 6.41211H5.55005V11.9996H24V6.41211Z",
    fill: "#2C7BD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12H5.55005V17.5875H24V12Z",
    fill: "#195ABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9126 23.1566H6.65635C6.05635 23.1566 5.56885 22.6691 5.56885 22.0691V17.5879H24.0001V22.0691C24.0001 22.6691 23.5126 23.1566 22.9126 23.1566Z",
    fill: "#103E91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1563 18.0938H1.2188C0.562549 18.0938 0.0187988 17.55 0.0187988 16.8937V7.10625C0.0187988 6.45 0.562549 5.90625 1.2188 5.90625H11.1563C11.8125 5.90625 12.3563 6.45 12.3563 7.10625V16.8937C12.3563 17.55 11.8313 18.0938 11.1563 18.0938Z",
    fill: "#2166C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6187 15.45L1.94995 8.71875H3.2812L3.93745 11.775C4.1062 12.6 4.27495 13.4438 4.38745 14.1188H4.4062C4.5187 13.4063 4.7062 12.6188 4.8937 11.7563L5.62495 8.71875H6.93745L7.61245 11.8125C7.7812 12.6188 7.9312 13.35 8.02495 14.0812H8.0437C8.1562 13.3312 8.32495 12.5813 8.51245 11.7563L9.22495 8.71875H10.5L8.66245 15.45H7.31245L6.59995 12.2812C6.4312 11.5312 6.29995 10.8938 6.2062 10.1625H6.18745C6.07495 10.875 5.9437 11.5312 5.73745 12.3L4.94995 15.4688H3.6187V15.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.3563 6.99414C12.3563 7.03164 12.3563 7.06914 12.3563 7.10664V16.8941C12.3563 17.5504 11.8126 18.0941 11.1563 18.0941H5.56885V19.1629H12.1688C12.8251 19.1629 13.3688 18.6191 13.3688 17.9629V8.17539C13.3688 7.57539 12.9376 7.06914 12.3563 6.99414Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3369_8566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.293bf5ab0c7b4905a571422199591eac.svg";
export { ForwardRef as ReactComponent };